import { render, staticRenderFns } from "./screen-layout.vue?vue&type=template&id=1a36ff24&scoped=true&"
import script from "./screen-layout.vue?vue&type=script&lang=js&"
export * from "./screen-layout.vue?vue&type=script&lang=js&"
import style0 from "./screen-layout.vue?vue&type=style&index=0&id=1a36ff24&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a36ff24",
  null
  
)

export default component.exports